import { render, staticRenderFns } from "./ExportXlsxResult.vue?vue&type=template&id=72ae54bb&scoped=true&"
import script from "./ExportXlsxResult.vue?vue&type=script&lang=js&"
export * from "./ExportXlsxResult.vue?vue&type=script&lang=js&"
import style0 from "./ExportXlsxResult.vue?vue&type=style&index=0&id=72ae54bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae54bb",
  null
  
)

export default component.exports